<template>
  <ElDialog
      v-model="isShow"
      class="allocate-space-dialog"
      :footer="null"
      centered
      :width="500"
      destroyOnClose
      @cancel="close"
  >
    <template #title>
   <!-- {{companyInformation}}
    <br>
         {{ userDataInformation }} -->
      <!--      {{ Math.floor((userDataInformation?.mailStorageVo?.freeLocation || 0) / 1024) }}-->
      <!--      {{-->
      <!--        Math.floor(-->
      <!--            ((companyInformation?.freeLocation || 0) - -->
      <!--                (userDataInformation?.mailStorageVo?.effectiveLocation || 0)) / 1024-->
      <!--        )-->
      <!--      }}-->
      <!--      {{ currentItem }}-->
      <span class="dialog-title">{{ $t('system.area') }}</span>
    </template>
    <div class="dialog-content">
      <div class="title_second">
        {{ $t('userinfo.center.child', {account: currentItem?.account}) }}
      </div>
      <div class="form-list">
        <div class="form-item">
          <span class="label-prefix">{{ $t('common.fp') }}</span>
        <el-input-number
            size="small"
            :precision="2"
            v-model="numSpace"
            @change="(value)=>handleChange(value,1)"
            @blur="() => handleBlur(1)"
        />
          <span class="unit-text unit-text-space">MB</span>
          <span>{{ $t('userinfo.vip.space') }}</span>
          <div class="des_bottom" v-html="targetText"></div>
        </div>
        <div class="form-item">
          <span class="label-prefix">{{ $t('common.fp') }}</span>
          <el-input-number
              size="small"
              :precision="0"
              v-model="numEdm"
              @change="(value)=>handleChange(value,2)"
              @blur="() => handleBlur(2)"
          />
          <span class="unit-text">{{ $t('common_ph23') }}</span>
          <span>{{ $t('userinfo.vip.edm') }}</span>
          <div class="des_bottom" v-html="targetText2">
          </div>
        </div>
        <div class="form-item">
          <span class="label-prefix">{{ $t('common.fp') }}</span>
          <el-input-number
              size="small"
              :precision="2"
              v-model="numAI"
              @change="(value)=>handleChange(value,3)"
              @blur="() => handleBlur(3)"
          />
          <span class="unit-text">{{ $t('common_ph24') }}</span>
          <span>{{ $t('userinfo.vip.AI') }}</span>
          <div class="des_bottom" v-html="targetText3"></div>
        </div>
      </div>
      <div class="tip">
        {{ $t('userinfo.center.tips') }}
      </div>
    </div>
    <div class="dialog-footer">
      <ElButton size="small" @click="close">
        {{
          $t("common.cancel")
        }}
      </ElButton>
      <ElButton size="small" type="primary" @click="handleClick" :loading="loading">{{ $t('common.confirm') }}
      </ElButton>
    </div>

  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import DialogTwo from "@/components/DiaPops/ChildUserDelete/DialogTwo.vue";
import {distributionLocation} from "@/api/usercenter";
import {formatSize, spaceSizeFormat} from "../../utils/file";
import {isEmpty} from "@/utils/mylodash";
import {i18n} from "@/lang";
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const loading = ref(false)
const numSpace = ref(0)
const numEdm = ref(0)
const numAI = ref(0)
const companyInformation = computed(() => store.state.user.companyInformation)
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const {value, isHeadLine, currentItem} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

const update = () => {
  emit("update");
}

const roundToTwoDecimals = (value) => {
  const numberValue = Number(value ?? 0)
  if (!Number.isFinite(numberValue)) return '0.00'
  return (Math.round((numberValue + Number.EPSILON) * 100) / 100).toFixed(2)
}

const formatInteger = (value) => {
  const numberValue = Number(value ?? 0)
  if (!Number.isFinite(numberValue)) return '0'
  return `${Math.round(numberValue)}`
}

const formatSpaceWithTwoDecimals = (bytes) => {
  const numberValue = Number(bytes ?? 0)
  if (!Number.isFinite(numberValue) || numberValue <= 0) return '0.00 B'

  const symbols = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  const exp = Math.max(Math.floor(Math.log(numberValue) / Math.log(2)), 0)
  const unitIndex = Math.floor(exp / 10)
  const targetValue = numberValue / Math.pow(2, 10 * unitIndex)

  return `${roundToTwoDecimals(targetValue)} ${symbols[unitIndex]}`
}

const normalizeInputValue = (value, precision = 2) => {
  const numberValue = Number(value ?? 0)
  if (!Number.isFinite(numberValue)) return 0
  const factor = 10 ** precision
  return Math.round((numberValue + Number.EPSILON) * factor) / factor
}

const targetText = computed(() => t('userinfo.center.sent', {
  //use: formatSpaceWithTwoDecimals(
  //    (companyInformation.value?.freeLocation ?? 0) - (userDataInformation.value?.mailStorageVo?.effectiveLocation ?? 0)
 // ),
  use:formatSpaceWithTwoDecimals(currentItem?.effectiveLocation ?? 0),
  recycle: formatSpaceWithTwoDecimals(currentItem?.effectiveLocation ?? 0),
  total: formatSpaceWithTwoDecimals(userDataInformation.value?.mailStorageVo?.freeLocation ?? 0)
}))

const unit = ref(i18n.global.t('common_ph23'))
const targetText2 = computed(() => t('userinfo.center.sent', {
  //use: `${formatInteger((companyInformation.value?.edmTotalNum ?? 0) - (userDataInformation.value?.freeEdmNum ?? 0))}${unit.value}`,
  use:`${formatInteger(currentItem?.totalEdmNum ?? 0)}${unit.value}`,
  recycle: `${formatInteger(currentItem?.freeEdmNum ?? 0)}${unit.value}`,
  total: `${formatInteger(userDataInformation.value?.freeEdmNum ?? 0)}${unit.value}`
}))

const unitSp = ref(i18n.global.t('common_ph24'))
const targetText3 = computed(() => t('userinfo.center.sent', {
  //use: `${roundToTwoDecimals((companyInformation.value?.totalAiNum ?? 0) - (userDataInformation.value?.freeAiNum ?? 0))}${unitSp.value}`,
  use:`${roundToTwoDecimals(currentItem?.totalAiNum ?? 0)}${unitSp.value}`,
  recycle: `${roundToTwoDecimals(currentItem?.freeAiNum ?? 0)}${unitSp.value}`,
  total: `${roundToTwoDecimals(userDataInformation.value?.freeAiNum ?? 0)}${unitSp.value}`
}))


const visibleDialogTwo = ref(false)
const handleDelete = () => {
  visibleDialogTwo.value = true
}

const deleteTarget = () => {
  emit("deleteTarget")
}

const maxLimit = computed(() =>
    Math.floor((userDataInformation.value?.mailStorageVo?.freeLocation || 0) / 1024)
)
const minLimit = computed(() => {
  const diff = currentItem?.effectiveLocation
  return Math.floor(-diff / 1024) // 保证是负数
})

const maxLimitEDM = computed(() => (userDataInformation.value?.freeEdmNum || 0))
const minLimitEDM = computed(() => {
  const diff = currentItem?.freeEdmNum
  console.log(diff, 'diff')
  return -diff
})

const maxLimitAI = computed(() => (userDataInformation.value?.freeAiNum || 0))
const minLimitAI = computed(() => {
  const diff = currentItem?.freeAiNum
  return -diff
})

const handleChange = (val, type) => {
  console.log(val, type, 'val')
  if (type === 1) {
    numSpace.value = limitSpaceInput(val, minLimit.value, maxLimit.value)
  } else if (type === 2) {
    numEdm.value = limitSpaceInput(val, minLimitEDM.value, maxLimitEDM.value)
  } else if (type === 3) {
    numAI.value = limitSpaceInput(val, minLimitAI.value, maxLimitAI.value)
  }
}

const handleBlur = (type) => {
  if (type === 1) {
    numSpace.value = limitSpaceInput(normalizeInputValue(numSpace.value, 2), minLimit.value, maxLimit.value)
  } else if (type === 2) {
    numEdm.value = limitSpaceInput(normalizeInputValue(numEdm.value, 0), minLimitEDM.value, maxLimitEDM.value)
  } else if (type === 3) {
    numAI.value = limitSpaceInput(normalizeInputValue(numAI.value, 2), minLimitAI.value, maxLimitAI.value)
  }
}

/**
 * 限制空间输入值在指定范围内
 * @param {number} val 用户输入值（KB）
 * @param {number} min 最小值（KB）
 * @param {number} max 最大值（KB）
 * @returns {number} 限制后的值
 */
const limitSpaceInput = (val, min, max) => {
  if (min > max) {
    console.warn(`[limitSpaceInput] min (${min}) > max (${max})，请检查逻辑`);
  }
  if (val > max) return max
  if (val < min) return min
  return val
}

// 分配空间
const handleClick = async () => {
  try {
    loading.value = true
    const payload = {
      id: currentItem?.id,
      locationNum: numSpace.value * 1024,
      edmNum: numEdm.value,
      aiNum: numAI.value,
    }
    await distributionLocation(payload).then(res => {
      if (res.code === 200) {
        ElMessage.success(res.result)
        update()
        close()
      }
    })
  } catch (e) {
    loading.value = false
  }
}

onMounted(async () => {
  await store.dispatch("user/getCompanyCurrentInfoApis")
  if (isEmpty(userDataInformation)) {
    await store.dispatch("cloud/queryByUserIdApis")
  }
})
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.allocate-space-dialog {
  font-size: 14px;
}

.allocate-space-dialog :deep(.el-dialog__header) {
  padding: 20px 24px 12px;
  margin-right: 0;
}

.allocate-space-dialog :deep(.el-dialog__body) {
  padding: 0 24px;
  font-size: 14px;
}

.allocate-space-dialog :deep(.el-dialog__footer) {
  padding: 0 24px 24px;
}

.allocate-space-dialog :deep(.el-button) {
  font-size: 14px;
}

.allocate-space-dialog :deep(.el-input-number .el-input__inner) {
  font-size: 14px;
}

.dialog-title {
  display: block;
  font-size: 14px;
  font-weight: 500;
}

.dialog-content {
  box-sizing: border-box;
}

.form-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.form-item {
  margin-top: 15px;
}

.label-prefix {
  margin-right: 10px;
}

.unit-text {
  color: #0a84ff;
  font-weight: 600;
  margin: 0 10px;
}

.unit-text-space {
  margin: 0 6px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

.dialog-footer {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.font {
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.font_middle {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 32px;
}

.title_second {
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tip {
  margin-top: 20px;
  font-size: 14px;
}

.des_bottom {
  margin-top: 5px;
  width: 100%;
  line-height: 22px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
